import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/global.css';

export default function MembershipPage() {
  const navigate = useNavigate();

  return (
    <div className="center-container">
      <h1>ChronoTech Robotics Memberships</h1>
      <p>Become a member and gain access to exclusive units, discounts, and extra features!</p>
      <div className="button-container">
        <button className="primary-button" onClick={() => navigate('/membership/login')}>Login</button>
      </div>
    </div>
  );
}
